<template>
  <CCard style="margin-top: 10px">
    <!-- <CCardHeader>
      <h4>{{ token.name }} Balance: {{ this.balancedata }} </h4>
     
    </CCardHeader> -->
    <CCardBody>
      <CRow>
        <CCol sm="6" >
          <CCard>
            <CCardHeader>
              <span style="font-size: 14px; font-weight: bold">NFT</span>

              <input
                type="checkbox"
                value="test"
                v-model="token.NFT"
                style="float: right; width: 113px; height: 22px"
              />
            </CCardHeader>
          </CCard>
        </CCol>
        <CCol sm="6" ><CCard>
            <CCardHeader>
              <span style="font-size: 14px; font-weight: bold">WhiteList</span>

              <input
                type="checkbox"
                value="test"
                v-model="token.isWhiteList"
                style="float: right; width: 113px; height: 22px"
              />
            </CCardHeader>
          </CCard> </CCol>
        <CCol sm="6">
          <CInput
            label="Symbol"
            placeholder="Enter your Symbol name"
            v-model="token.name"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="Name"
            placeholder="Enter your  name"
            v-model="token.symbol"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="Total supply"
            placeholder=""
            v-model="token.totalSupply"
        /></CCol>
        <CCol sm="6">
          <CRow>
            <CCol sm="8">
              <CInput
                label="Available supply"
                placeholder="Enter Total supply"
                v-model="token.availableSupply"
              />
            </CCol>

            <CCol sm="4">
              <br />
              <CButton
                block
                color="success"
                style="float: right; width: 100px"
                @click="myModal = true"
                >Add coin</CButton
              >
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="12">
          <!-- <CCardHeader>
            Country
          </CCardHeader> -->
          <span>Country</span>
          <CCardBody v-if="this.allCountry">
            All Country
            <CButton
              block
              color="success"
              style="float: right; width: 250px"
              @click="changetoParticular()"
              >change to particular Country</CButton
            ><br /><br />
            <CInput
              placeholder="Enter Total supply"
              v-model="token.totalSupply"
              type="number"
            />
          </CCardBody>
          <CCardBody v-if="this.particularCountry">
            Particular country
            <CButton
              block
              color="success"
              style="float: right; width: 250px"
              @click="changetoallcountry()"
              >Change to all Country</CButton
            ><br /><br />
            <div
              class="form-group"
              v-for="(input, k) in this.token.country"
              :key="k"
            >
              <CRow>
                <CCol sm="4">
                  <Vselect
                    v-model="input.name"
                    :options="country"
                    searchable
                  ></Vselect>
                </CCol>
                <CCol sm="6">
                  <input
                    type="number"
                    class="form-control"
                    v-model="input.tokenAmount"
                  />
                </CCol>
                <CCol sm="2">
                  <span>
                    <CButton
                      color="danger"
                      @click="remove(k)"
                      v-show="k || (!k && token.country.length > 1)"
                    >
                      <i class="fa fa-times"></i></CButton
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <CButton
                      color="success"
                      @click="add(k)"
                      v-show="k == token.country.length - 1"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i
                    ></CButton>
                  </span>
                </CCol>
              </CRow>
            </div>
          </CCardBody>
        </CCol>
        <CCol sm="6">
          <br />
          <CInput
            label="Token coinLimit"
            placeholder="Enter token coinLimit"
            v-model.number="token.coinLimit"
          />
        </CCol>
        <CCol sm="6">
          <br />
          <CInput
            label="Token Rage (Radius)"
            placeholder="Enter token rage"
            v-model="token.radius"
          />
        </CCol>
        <CCol sm="6">
          <br />
          <CInput
            label="Token limit(show max)"
            placeholder="Enter token limit"
            v-model="token.showMax"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="Company"
            placeholder="Enter Company  name"
            v-model="token.companyName"
          />
        </CCol>
        <CCol sm="6">
          <CRow>
            <CCol sm="8">
              <label>Company logo</label>
              <div v-if="logoimg">
                <img
                  class="preview"
                  :src="token.logo"
                  style="width: 50px; border-radius: 50px; height: 50px"
                />
                <CButton
                  style="float: right"
                  color="success"
                  class="nftbtnupdate"
                  @click="piconeedit()"
                  >click to change</CButton
                >
              </div>
              <div v-if="logohide">
                <div>
                  <input type="file" @change="previewImage" accept="image/*" />
                </div>
                <div>
                  <p>
                    Progress: {{ uploadValue.toFixed() + "%" }}
                    <progress
                      id="progress"
                      :value="uploadValue"
                      max="100"
                    ></progress>
                  </p>
                </div>

                <button @click="onUpload()" v-if="uploadbtn">Upload</button>
              </div>
              <br />
              <br />
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="6">
          <CRow>
            <CCol sm="8">
              <label>Display logo</label>
              <div v-if="logoimg2">
                <img
                  class="preview"
                  :src="token.displaylogo"
                  style="width: 50px; border-radius: 50px; height: 50px"
                />
                <CButton
                  style="float: right"
                  color="success"
                  class="nftbtnupdate"
                  @click="pictwoedit()"
                  >click to change</CButton
                >
              </div>
              <div v-if="logohide2">
                <div>
                  <input type="file" @change="previewImage2" accept="image/*" />
                </div>
                <div>
                  <p>
                    Progress: {{ uploadValue2.toFixed() + "%" }}
                    <progress
                      id="progress"
                      :value="uploadValue2"
                      max="100"
                    ></progress>
                  </p>
                </div>

                <button @click="onUpload2()" v-if="uploadbtn2">Upload</button>
              </div>
              <br />
              <br />
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="6">
          <CRow>
            <CCol sm="8">
              <label>3D logo</label>
              <div v-if="logoimg3">
                <img
                  class="preview"
                  :src="token.arLogo"
                  style="width: 50px; border-radius: 50px; height: 50px"
                />
                <CButton
                  style="float: right"
                  color="success"
                  class="nftbtnupdate"
                  @click="picthreeedit()"
                  >click to change</CButton
                >
              </div>
              <div v-if="logohide3">
                <div>
                  <input type="file" @change="previewImage3" accept="image/*" />
                </div>
                <div>
                  <p>
                    Progress: {{ uploadValue3.toFixed() + "%" }}
                    <progress
                      id="progress"
                      :value="uploadValue3"
                      max="100"
                    ></progress>
                  </p>
                </div>

                <button @click="onUpload3()" v-if="uploadbtn3">Upload</button>
              </div>
              <br />
              <br />
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="6">
          <CRow>
            <CCol sm="8">
              <label>Capture logo</label>
              <div v-if="logoimg4">
                <img
                  class="preview"
                  :src="token.capturelogo"
                  style="width: 50px; border-radius: 50px; height: 50px"
                />
                <CButton
                  style="float: right"
                  color="success"
                  class="nftbtnupdate"
                  @click="picfouredit()"
                  >click to change</CButton
                >
              </div>
              <div v-if="logohide4">
                <div>
                  <input type="file" @change="previewImage4" accept="image/*" />
                </div>
                <div>
                  <p>
                    Progress: {{ uploadValue4.toFixed() + "%" }}
                    <progress
                      id="progress"
                      :value="uploadValue4"
                      max="100"
                    ></progress>
                  </p>
                </div>

                <button @click="onUpload4()" v-if="uploadbtn4">Upload</button>
              </div>
              <br />
              <br />
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="6">
          <CRow>
            <CCol sm="8">
              <label>Popup logo</label>
              <div v-if="logoimg6">
                <img
                  class="preview"
                  :src="token.popuplogo"
                  style="width: 50px; border-radius: 50px; height: 50px"
                />
                <CButton
                  style="float: right"
                  color="success"
                  class="nftbtnupdate"
                  @click="picsixedit()"
                  >click to change</CButton
                >
              </div>
              <div v-if="logohide6">
                <div>
                  <input type="file" @change="previewImage6" accept="image/*" />
                </div>
                <div>
                  <p>
                    Progress: {{ uploadValue6.toFixed() + "%" }}
                    <progress
                      id="progress"
                      :value="uploadValue6"
                      max="100"
                    ></progress>
                  </p>
                </div>

                <button @click="onUpload6()" v-if="uploadbtn6">Upload</button>
              </div>
              <br />
              <br />
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="6">
          <CRow>
            <CCol sm="8">
              <label>Network logo</label>
              <div v-if="logoimg7">
                <img
                  class="preview"
                  :src="token.networkimage"
                  style="width: 50px; border-radius: 50px; height: 50px"
                />
                <CButton
                  style="float: right"
                  color="success"
                  class="nftbtnupdate"
                  @click="picsevenedit()"
                  >click to change</CButton
                >
              </div>
              <div v-if="logohide7">
                <div>
                  <input type="file" @change="previewImage7" accept="image/*" />
                </div>
                <div>
                  <p>
                    Progress: {{ uploadValue7.toFixed() + "%" }}
                    <progress
                      id="progress"
                      :value="uploadValue7"
                      max="100"
                    ></progress>
                  </p>
                </div>

                <button @click="onUpload7()" v-if="uploadbtn7">Upload</button>
              </div>
              <br />
              <br />
            </CCol>
          </CRow>
        </CCol>

        <CCol sm="6" v-if="token.nftImage!='' ">
          <CRow>
            <CCol sm="8" >
              <label>NFT Image </label>
              <div v-if="logoimg8">
                <img
                  class="preview"
                  :src="token.nftImage"
                  style="width: 50px; border-radius: 50px; height: 50px"
                />
                <CButton
                  style="float: right"
                  color="success"
                  class="nftbtnupdate"
                  @click="piceightedit()"
                  >click to change</CButton
                >
              </div>
              <div v-if="logohide8">
                <div>
                  <input type="file" @change="previewImage8" accept="image/*" />
                </div>
                <div>
                  <p>
                    Progress: {{ uploadValue8.toFixed() + "%" }}
                    <progress
                      id="progress"
                      :value="uploadValue8"
                      max="100"
                    ></progress>
                  </p>
                </div>

                <button @click="onUpload8()" v-if="uploadbtn8">Upload</button>
              </div>
              <br />
              <br />
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="6" v-if="token.audiofile!='' ">
          <CRow>
            <CCol sm="8" >
              <label>NFT Audio </label>
              <div v-if="logoimg9">
                <vue-audio :file="token.audiofile"></vue-audio>
                <CButton
                  style="float: right"
                  color="success"
                  class="nftbtnupdate"
                  @click="picnineedit()"
                  >click to change</CButton
                >
              </div>
              <div v-if="logohide9">
                <div>
                  <input type="file" @change="previewImage9" accept="image/*" />
                </div>
                <div>
                  <p>
                    Progress: {{ uploadValue9.toFixed() + "%" }}
                    <progress
                      id="progress"
                      :value="uploadValue9"
                      max="100"
                    ></progress>
                  </p>
                </div>

                <button @click="onUpload9()" v-if="uploadbtn9">Upload</button>
              </div>
              <br />
              <br />
            </CCol>
          </CRow>
        </CCol>
        <!-- <CCol sm="6">
          <CRow>
            <CCol sm="3">
              <label v-if="logohide1">Display logo</label>
              <img
                v-if="logohide1"
                :src="token.displaylogo"
                style="width: 50px; border-radius: 50px; height: 50px"
              />
              <label v-if="logounhide1">Choose logo</label>
              <br />
              <input
                v-if="logounhide1"
                type="file"
                accept="image/jpeg"
                @change="uploadImage1"
              />
              <input v-model="token.displaylogo" type="hidden" />
            </CCol>
            <CCol sm="9">
              <br />
              <br />

              <CButton
                v-if="logohide1"
                block
                color="success"
                style="width: 100px"
                @click="imghide1()"
              >
                click to edit</CButton
              >
              <CButton
                block
                color="success"
                style="float: right; width: 100px"
                v-if="logoimg1"
                @click="savedisplaylogo()"
                >upload</CButton
              >
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="6"
          ><CRow>
            <CCol sm="3">
              <label v-if="logohide3">3D Logo</label>
              <img
                v-if="logohide3"
                :src="token.arLogo"
                style="width: 50px; border-radius: 50px; height: 50px"
              />
              <label v-if="logounhide2">Choose logo</label>
              <br />
              <input
                v-if="logounhide3"
                type="file"
                accept="image/jpeg"
                @change="uploadImage3"
              />
              <input v-model="token.arLogo" type="hidden" />
            </CCol>
            <CCol sm="9">
              <br />
              <br />

              <CButton
                v-if="logohide3"
                block
                color="success"
                style="width: 100px"
                @click="imghide3()"
              >
                click to edit</CButton
              >
              <CButton
                block
                color="success"
                style="float: right; width: 100px"
                v-if="logoimg3"
                @click="savetokenthreelogo()"
                >upload</CButton
              >
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="6">
          <CRow>
            <CCol sm="3">
              <label v-if="logohide2">Capture logo</label>
              <img
                v-if="logohide2"
                :src="token.capturelogo"
                style="width: 50px; border-radius: 50px; height: 50px"
              />
              <label v-if="logounhide2">Choose logo</label>
              <br />
              <input
                v-if="logounhide2"
                type="file"
                accept="image/jpeg"
                @change="uploadImage2"
              />
              <input v-model="token.capturelogo" type="hidden" />
            </CCol>
            <CCol sm="9">
              <br />
              <br />

              <CButton
                v-if="logohide2"
                block
                color="success"
                style="width: 100px"
                @click="imghide2()"
              >
                click to edit</CButton
              >
              <CButton
                block
                color="success"
                style="float: right; width: 100px"
                v-if="logoimg2"
                @click="savetokencapturelogo()"
                >upload</CButton
              >
            </CCol>
          </CRow>
        </CCol> -->
        <CCol sm="6">
          <br />
          <CInput
            label="Network"
            placeholder="Enter network"
            v-model="token.network"
          />
        </CCol>
        <CCol sm="6">
          <CTextarea
            label="Description"
            placeholder="Content..."
            horizontal
            rows="5"
            v-model="token.description"
          />
        </CCol>
        <CCol sm="6">
          <br />
          <CInput
            label="Ethereum Address"
            placeholder="Enter Ethereum Address"
            v-model="token.ethAddress"
          />
        </CCol>
        <CCol sm="6">
          <br />
          <CInput
            label="Contract Address"
            placeholder="Enter Ethereum Address"
            v-model="token.conAddress"
          />
        </CCol>
        <CCol sm="6">
          <br />
          <CInput
            label="Private key"
            placeholder="Enter privatekey"
            v-model="token.privatekey"
          />
        </CCol>
        <CCol sm="6">
          <br />
          <span style="font-size: 14px">Location</span>
          <br />
          <multiselect
            v-model="token.location"
            :options="this.multiselectOptions"
            :multiple="true"
          />
        </CCol>
        <CCol sm="6">
          <span style="font-size: 14px">whiteList</span>
          <br />

          <CButton
            color="success"
            @click="largeModal = true"
            class="mr-1"
            v-if="enablewhite"
          >
            click to view whiteList </CButton
          ><br />
          <CAlert
            :show.sync="dismissCountDown"
            v-if="showAlerts"
            closeButton
            color="success"
            fade
          >
            Data uploaded
            <!-- <strong>{{dismissCountDown}}</strong> seconds... -->
          </CAlert>
          <span style="font-size: 14px">Update whitelist here</span><br />
          <span style="color: red">Please upload .CSV file</span><br />
          <input
            id="fileInput"
            type="file"
            @change="upload"
            accept=".csv"
            ref="input"
          />
          <br />
        </CCol>
        <CCol sm="6">
          <CInput
            label="LinkedinID"
            placeholder="Enter LinkedinID"
            v-model="token.linkedinID"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="TwitterID"
            placeholder="EnterTwitterID"
            v-model="token.twitterID"
          />
        </CCol>
        <CCol sm="6">
          <span style="font-size: 14px">Token Promo GIF / Video</span><br /><br />

          <CCard >
            <img :src="token.videoupload" style="height: 350px; width: 350px" v-if="token.NFT==false"/>
            <video v-else
                      width="450"
                      height="300"
                      class="preview"
                      controls
                      :src="token.videoupload"
                      style="
                        
                       
                      "
                    ></video>
          </CCard>
        </CCol>
        <CCol sm="6">
          <h5>Update token promo here</h5>
          <span style="color: red">Please upload .gif / .mp4 file</span><br />
          <!-- <span style="font-size: 14px"></span>
          <br />

          <div class="file-upload">
            <input type="file" @change="onFileChange" accept="/mp4" />
            <CButton
              color="success"
              @click="onUploadFile"
              class="upload-button"
              v-if="selectedFile"
              :disabled="!this.selectedFile"
              >Upload file</CButton
            >
          </div> -->
          <div>
            <div>
              <input type="file" @change="previewImage5" accept="image/*" />
            </div>
            <div>
              <p>
                Progress: {{ uploadValue5.toFixed() + "%" }}
                <progress
                  id="progress"
                  :value="uploadValue5"
                  max="100"
                ></progress>
              </p>
            </div>

            <button @click="onUpload5()" v-if="uploadbtn5">Upload</button>
          </div>
        </CCol>
        <CCol sm="6">
          <CInput
            label="Dailylimit"
            placeholder="Enter LinkedinID"
            v-model.number="token.dailyLimit"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="MaxLimit"
            placeholder="Enter MaxLimit"
            v-model.number="token.maxLimit"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="CoinQty"
            placeholder="Enter coinQty"
            v-model.number="token.coinQty"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="UserLimit"
            placeholder="Enter userLimit"
            v-model.number="token.userLimit"
          />
        </CCol>
        <CRow v-if="messageset">
          <CCol sm="6">
            <span style="font-size: 14px">Token hunt message </span>

            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Message 1"
                :maxlength="max"
                v-model="token.msg1"
              />
              <div
                class="input-group-addon inputlength"
                v-text="max - token.msg1.length"
              ></div>
            </div> </CCol
          ><br />
          <CCol sm="6">
            <br />
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Message 2"
                :maxlength="max"
                v-model="token.msg2"
              />
              <div
                class="input-group-addon inputlength"
                v-text="max2 - token.msg2.length"
              ></div>
            </div> </CCol
          ><br />
          <CCol sm="6">
            <br />
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Message 3"
                :maxlength="max3"
                v-model="token.msg3"
              />
              <div
                class="input-group-addon inputlength"
                v-text="max3 - token.msg3.length"
              ></div>
            </div> </CCol
          ><br />
          <CCol sm="6">
            <br />
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Message 4"
                :maxlength="max4"
                v-model="token.msg4"
              />
              <div
                class="input-group-addon inputlength"
                v-text="max4 - token.msg4.length"
              ></div>
            </div> </CCol
          ><br />
          <CCol sm="6">
            <br />
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Message 5"
                :maxlength="max5"
                v-model="token.msg5"
              />
              <div
                class="input-group-addon inputlength"
                v-text="max5 - token.msg5.length"
              ></div>
            </div> </CCol
          ><br />
          <CCol sm="6">
            <br />
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Message 6"
                :maxlength="max6"
                v-model="token.msg6"
              />
              <div
                class="input-group-addon inputlength"
                v-text="max6 - this.token.message[5].length"
              ></div>
            </div>
          </CCol>
        </CRow>
        <br />
        <CCol sm="12" v-if="messagelinkset">
          <br />
          <span style="font-size: 14px">Token Message with link</span>
          <br />

          <br />

          <div
            class="form-group"
            v-for="(input, k) in this.token.messagelink"
            :key="k"
          >
            <CRow>
              <CCol sm="6">
                <input
                  type="text"
                  class="form-control"
                  v-model="input.tokenmessage"
                />
              </CCol>
              <CCol sm="4">
                <input
                  type="text"
                  class="form-control"
                  v-model="input.tokenmessagelink"
                />
              </CCol>
              <CCol sm="2">
                <span>
                  <CButton
                    color="danger"
                    @click="remove1(k)"
                    v-show="k || (!k && token.messagelink.length > 1)"
                  >
                    <i class="fa fa-times"></i></CButton
                  >&nbsp;&nbsp;&nbsp;
                  <CButton
                    color="success"
                    @click="add1(k)"
                    v-show="k == token.messagelink.length - 1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i
                  ></CButton>
                </span>
              </CCol>
            </CRow>
          </div>
        </CCol>
        <div style="margin: auto; margin-top: 50px">
          <CButton
            block
            color="success"
            style="width: 200px"
            @click="updateToken()"
            >Save</CButton
          >
        </div>
      </CRow>
    </CCardBody>
    <CModal title="whiteList" size="lg" :show.sync="largeModal">
 <span v-for="(item,i) in this.whiteItem" :key="i" >
           {{item}}<br>
           <hr>
      </span>
    </CModal>
    <CModal title="Add Coin" :show.sync="myModal">
      <CInput placeholder="Enter coin" v-model="addCoin" type="number" />
      <span v-if="filetext" style="color: red">please enter coin</span>
      <template #footer>
        <!-- <CButton @click="darkModal = false" color="danger">cancel</CButton> -->
        <CButton @click="updateCoin()" color="success">add</CButton>
      </template>
    </CModal>
  </CCard>
</template>

<script>
import CTableWrapper from "../tables/Table";
import Multiselect from "vue-multiselect";
import { Vselect } from "@/components";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import firebase from "firebase";
import Papa from "papaparse";
import "vue-gifplayer/src/gif.css";
import axios from "axios";
import VueAudio from "vue-audio";
const db = firebase.firestore();
const today = new Date();

export default {
  name: "advanced-forms",
  components: {
    Multiselect,
    Vselect,
    CTableWrapper,
    VueAudio,
  },
  data() {
    return {
      allCountry: false,
      particularCountry: false,
      showAlerts: false,
      darkModal: false,
      messageset: false,
      messagelinkset: false,
      dismissSecs: 3,
      dismissCountDown: 3,
      balancedata: "",
      fields: [
        {
          key: "address",
        },
      ],
      max: 60,
      max2: 60,
      max3: 60,
      max4: 60,
      max5: 60,
      max6: 60,
      addCoin: "",
      updateCoins: "",
      enablewhite: false,
      largeModal: false,
      myModal: false,
      token: {
        audiofile: "",
        nftImage: "",
        network: "",
        tokenrage: "",
        name: "",
        symbol: "",
        logo: "",
        totalSupply: "",
        companyName: "",
        description: "",
        location: "",
        twitterID: "",
        linkedinID: "",
        isWhiteList: false,
        whiteList: [],
        videoupload: "",
        isVideoselected: false,
        capturelogo: "",
        displaylogo: "",
        popuplogo: "",
        arLogo: "",
        networkimage: "",
        msg1: "",
        msg2: "",
        msg3: "",
        msg4: "",
        msg5: "",
        msg6: "",
        dailyLimit: 0,
        maxLimit: 0,
        userLimit: 0,
        coinLimit: 0,
        coinQty: 0,
        NFT: null,
        messagelink: [
          {
            tokenmessage: "",
            tokenmessagelink: "",
          },
        ],
      },
      selectedFile: "",
      logoimg: true,
      logohide: false,
      uploadValue: 0,
      uploadbtn: false,

      logoimg2: true,
      logohide2: false,
      uploadValue2: 0,
      uploadbtn2: false,

      logoimg3: true,
      logohide3: false,
      uploadValue3: 0,
      uploadbtn3: false,

      logoimg4: true,
      logohide4: false,
      uploadValue4: 0,
      uploadbtn4: false,

      logoimg5: true,
      logohide5: false,
      uploadValue5: 0,
      uploadbtn5: false,

      logoimg6: true,
      logohide6: false,
      uploadValue6: 0,
      uploadbtn6: false,

      logoimg7: true,
      logohide7: false,
      uploadValue7: 0,
      uploadbtn7: false,

      logoimg8: true,
      logohide8: false,
      uploadValue8: 0,
      uploadbtn8: false,

      logoimg9: true,
      logohide9: false,
      uploadValue9: 0,
      uploadbtn9: false,

      isFirst: false,
      country: [],
      state: [],
      city: [],
      countryInfo: [],
      stateInfo: [],
      cityInfo: [],
      tokencsc: {
        companyCountry: "",
        companyState: "",
        companyCity: "",
        location: [],
        country: [
          {
            name: "",
            tokenAmount: "",
          },
        ],
      },
      imageTypes: ["image/jpeg", "image/png", "image/jpg"],
      imageUploaded: false,
      date: "",
      phone: "",
      taxid: "",
      ssn: "",
      eye: "",
      ccn: "",
      multi: null,
      selected: null,
      filetext: false,
      selectedDate: {
        start: new Date(today.getFullYear(), today.getMonth(), 7),
        end: new Date(today.getFullYear(), today.getMonth(), 11),
      },

      multiselectOptions: [
        "shopping_mall",
        "atm",
        "bakery",
        "bank",
        "bar",
        "park",
        "restaurant",
        "stadium",
        "supermarket",
        "subway_station",
      ],
      whiteItem: [],
    };
  },
  watch: {
        "token.isWhiteList"() {
      if (this.token.isWhiteList == true) {
        this.token.isWhiteList = true;
      } else if (this.token.isWhiteList == false) {
        this.token.isWhiteList = false;
      }
    },
    "token.NFT"() {
      if (this.token.NFT == true) {
        console.log("this.isNft", this.token.NFT);
        this.token.NFT = true;
      } else if (this.token.NFT == false) {
        console.log("this.isNft", this.token.NFT);
        this.token.NFT = false;
      }
    },
  },
  methods: {
    piconeedit() {
      (this.logoimg = false), (this.logohide = true);
    },
    pictwoedit() {
      (this.logoimg2 = false), (this.logohide2 = true);
    },
    picthreeedit() {
      (this.logoimg3 = false), (this.logohide3 = true);
    },
    picfouredit() {
      (this.logoimg4 = false), (this.logohide4 = true);
    },
    picfiveedit() {
      (this.logoimg5 = false), (this.logohide5 = true);
    },
    picsixedit() {
      (this.logoimg6 = false), (this.logohide6 = true);
    },
    picsevenedit() {
      (this.logoimg7 = false), (this.logohide7 = true);
    },
    piceightedit() {
      (this.logoimg8 = false), (this.logohide8 = true);
    },
      picnineedit() {
      (this.logoimg9 = false), (this.logohide9 = true);
    },
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn = true;
      // }
    },

    onUpload() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`nftcards/${random_number}.${fileextension}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url", url);
            this.token.logo = url;
            if (this.token.logo.length > 0) {
              this.uploadbtn = false;
              this.logoimg = true;
              this.logohide = false;
            }
          });
        }
      );
    },

    previewImage2(event) {
      this.uploadValue2 = 0;
      this.picture2 = null;
      this.imageData2 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn2 = true;
      // }
    },

    onUpload2() {
      this.picture2 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData2.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`nftcards/${random_number}.${fileextension}`)
        .put(this.imageData2);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue2 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue2 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url", url);
            this.token.displaylogo = url;
            if (this.token.displaylogo.length > 0) {
              this.uploadbtn2 = false;
              this.logoimg2 = true;
              this.logohide2 = false;
            }
          });
        }
      );
    },

    previewImage3(event) {
      this.uploadValue3 = 0;
      this.picture = null;
      this.imageData3 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn3 = true;
      // }
    },

    onUpload3() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData3.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`nftcards/${random_number}.${fileextension}`)
        .put(this.imageData3);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue3 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue3 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url", url);
            this.token.arLogo = url;
            if (this.token.arLogo.length > 0) {
              this.uploadbtn3 = false;
              this.logoimg3 = true;
              this.logohide3 = false;
            }
          });
        }
      );
    },

    previewImage4(event) {
      this.uploadValue4 = 0;
      this.picture4 = null;
      this.imageData4 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn4 = true;
      // }
    },

    onUpload4() {
      this.picture4 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData4.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`nftcards/${random_number}.${fileextension}`)
        .put(this.imageData4);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue4 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue4 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url", url);
            this.token.capturelogo = url;
            if (this.token.capturelogo.length > 0) {
              this.uploadbtn4 = false;
              this.logoimg4 = true;
              this.logohide4 = false;
            }
          });
        }
      );
    },

    previewImage5(event) {
      this.uploadValue5 = 0;
      this.picture5 = null;
      this.imageData5 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn5 = true;
      // }
    },

    onUpload5() {
      this.picture5 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData5.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`nftcards/${random_number}.${fileextension}`)
        .put(this.imageData5);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue5 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue5 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url", url);
            this.token.videoupload = url;
            if (this.token.videoupload.length > 0) {
              this.uploadbtn5 = false;
              // this.logoimg4 = true;
              // this.logohide4 = false;
            }
          });
        }
      );
    },

    previewImage6(event) {
      this.uploadValue6 = 0;
      this.picture6 = null;
      this.imageData6 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn6 = true;
      // }
    },

    onUpload6() {
      this.picture6 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData6.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`nftcards/${random_number}.${fileextension}`)
        .put(this.imageData6);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue6 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue6 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url", url);
            this.token.popuplogo = url;
            if (this.token.popuplogo.length > 0) {
              this.uploadbtn6 = false;
              this.logoimg6 = true;
              this.logohide6 = false;
            }
          });
        }
      );
    },

    previewImage7(event) {
      this.uploadValue7 = 0;
      this.picture7 = null;
      this.imageData7 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn7 = true;
      // }
    },

    onUpload7() {
      this.picture7 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData7.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`nftcards/${random_number}.${fileextension}`)
        .put(this.imageData7);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue7 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue7 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url", url);
            this.token.networkimage = url;
            if (this.token.networkimage.length > 0) {
              this.uploadbtn7 = false;
              this.logoimg7 = true;
              this.logohide7 = false;
            }
          });
        }
      );
    },

    previewImage8(event) {
      this.uploadValue8 = 0;
      this.picture8 = null;
      this.imageData8 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn8 = true;
      // }
    },

    onUpload8() {
      this.picture8 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData8.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`nftcards/${random_number}.${fileextension}`)
        .put(this.imageData8);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue8 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue8 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url", url);
            this.token.nftImage = url;
            if (this.token.nftImage.length > 0) {
              this.uploadbtn8 = false;
              this.logoimg8 = true;
              this.logohide8 = false;
            }
          });
        }
      );
    },


      previewImage9(event) {
      this.uploadValue9 = 0;
      this.picture9 = null;
      this.imageData9 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn9 = true;
      // }
    },

    onUpload9() {
      this.picture9 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData9.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`nftcards/${random_number}.${fileextension}`)
        .put(this.imageData9);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue9 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue9 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url", url);
            this.token.audiofile = url;
            if (this.token.audiofile.length > 0) {
              this.uploadbtn9 = false;
              this.logoimg9 = true;
              this.logohide9 = false;
            }
          });
        }
      );
    },
    changetoParticular() {
      this.particularCountry = true;
      this.allCountry = false;
      this.token.particularCountry = true;
      this.token.allCountry = false;
    },
    changetoallcountry() {
      this.particularCountry = false;
      this.token.particularCountry = false;
      this.token.allCountry = true;
      this.allCountry = true;
    },
    add() {
      this.token.country.push({
        name: "",
        tokenAmount: "",
      });
      // console.log(this.token.country);
    },

    remove(index) {
      this.token.country.splice(index, 1);
    },
    add1() {
      this.token.messagelink.push({
        tokenmessage: "",
        tokenmessagelink: "",
      });
      console.log("messagelink", this.token.messagelink);
    },

    remove1(index) {
      this.token.messagelink.splice(index, 1);
    },
    updateCoin() {
      if (this.addCoin.length > 0) {
        this.updateCoins = parseInt(this.addCoin);

        this.token.totalSupply = this.token.totalSupply + this.updateCoins;
        this.token.availableSupply =
          this.token.availableSupply + this.updateCoins;

        this.myModal = false;
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Coin updated successfully",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        // console.log("enter input")
        this.filetext = true;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    onFileChange(e) {
      const selectedFile = e.target.files[0]; // accessing file
      this.selectedFile = selectedFile;
    },
    onUploadFile() {
      let self = this;
      let data = new FormData();
      data.append("file", self.selectedFile);
      if (self.selectedFile.type.match(/.(gif)$/i)) {
        // console.log("entered");
        APIService.reUploadvideo(data).then(
          (res) => {
            if (res.status == 200) {
              self.token.videoupload = res.data.location;

              if (self.token.videoupload.length > 0) {
                self.token.isVideoselected = true;
              }
              self.videoplayer = true;
              self.selectedFile = false;

              // console.log("user info heree", self.token);

              this.$notify({
                timeout: 1000,
                message: "Company logo uploaded successfully.",
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              Swal("Oops...", "Something went wrong!", "error");
            }
          },
          (err) => {
            self.errMsg = "Cannot upload Profile Image2";
          }
        );
      } else {
        // console.log("Oops...", "Something went wrong!", "error");
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Wrong format please upload .gif",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    upload(e) {
      const that = this;
      let fname = event.target.files[0].name.split(".");
      if (fname[1].toLowerCase() == "csv") {
        const fileToLoad = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (fileLoadedEvent) => {
          Papa.parse(fileLoadedEvent.target.result, {
            header: true,
            complete(results) {
              that.token.whiteList = [];

              for (let i = 0; i < results.data.length - 1; i++) {
                that.token.whiteList.push(results.data[i]);
              }
              if (that.token.whiteList.length > 0) {
                that.token.isWhiteList = true;
                that.showAlerts = true;
              }
            },
            error(errors) {
              // console.log("error", errors);
            },
          });
        };
        reader.readAsText(fileToLoad);
      } else {
        document.getElementById("fileInput").value = "";
      }
    },
    updateToken() {
      let self = this;
      console.log("db Entered", this.token.coinQty);

      db.collection("companyDetails2")
        .doc(this.id)
        .update({
          name: this.token.name,
          symbol: this.token.symbol,
          radius: parseInt(this.token.radius),
          showMax: parseInt(this.token.showMax),
          totalSupply: parseInt(this.token.totalSupply),
          availableSupply: parseInt(this.token.availableSupply),
          companyName: this.token.companyName,
          description: this.token.description,
          ethAddress: this.token.ethAddress,
          conAddress: this.token.conAddress,
          privatekey: this.token.privatekey,
          country: this.tokencsc.companyCountry,
          location: this.token.location,
          logo: this.token.logo,
          displaylogo: this.token.displaylogo,
          capturelogo: this.token.capturelogo,
          arLogo: this.token.arLogo,
          popuplogo: this.token.popuplogo,
          linkedinID: this.token.linkedinID,
          twitterID: this.token.twitterID,
          isWhiteList: this.token.isWhiteList,
          whiteList: this.token.whiteList,
          videoupload: this.token.videoupload,
          isVideoselected: this.token.isVideoselected,
          allCountry: this.token.allCountry,
          network: this.token.network,
          particularCountry: this.token.particularCountry,
          dailyLimit: this.token.dailyLimit,
          maxLimit: this.token.maxLimit,
          userLimit: this.token.userLimit,
          coinLimit: this.token.coinLimit,
          coinQty: this.token.coinQty,
          messagelink: this.token.messagelink,
          networkimage: this.token.networkimage,
          NFT: this.token.NFT,
          nftImage: this.token.nftImage,
          audiofile: this.token.audiofile,
          message: [
            this.token.msg1,
            this.token.msg2,
            this.token.msg3,
            this.token.msg4,
            this.token.msg5,
            this.token.msg6,
          ],
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 3000,
          });
          self.$router.push({ name: "tokenEntry" });
          // console.log("Document successfully written!");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },

    gettokens() {
      this.tableData = [];
      let newtake = {};
      const db = firebase.firestore();
      db.collection("companyDetails2")
        .doc(this.id)
        .get()
        .then((snapshot) => {
          console.log("AlltableData", snapshot.data());

          this.token = snapshot.data();
          newtake = snapshot.data();
          console.log("newtake", newtake.companyName);

          this.isFirst = true;

          this.tokencsc.companyCountry = this.token.country;

          if (this.token.isWhiteList == true) {
            this.enablewhite = true;
          }
          // console.log("changed to true", this.token.whiteList);

          this.whiteItem = this.token.whiteList;
          // console.log("location", this.token.message[5]);
          this.token.msg1 = this.token.message[0];
          this.token.msg2 = this.token.message[1];
          this.token.msg3 = this.token.message[2];
          this.token.msg4 = this.token.message[3];
          this.token.msg5 = this.token.message[4];
          this.token.msg6 = this.token.message[5];
          // console.log("this.token.allCountry",this.token.allCountry)
          if (this.token.allCountry == true) {
            this.allCountry = true;
          } else if (this.token.particularCountry == true) {
            this.particularCountry = true;
          }

          if (this.token.istokenmsg == true) {
            this.messageset = true;
          } else if (this.token.istokenmsglink == true) {
            this.messagelinkset = true;
          }
          //  console.log("this.token",this.token.istokenmsglink)
          // console.log("this.token.allCountry",this.token.istokenmsg)

          this.loading = false;

          // if (this.token.name == "Matic") {
          //   axios
          //     .get(
          //        "https://api.ethplorer.io/getAddressInfo/"+this.token.ethAddress +"?apiKey=freekey"
          //     // "https://api.ethplorer.io/getAddressInfo/0xB50Cc9a4269258E8fb49978E0E32932619b3bee1?apiKey=freekey"
          //     )
          //     .then((res) => {
          //       console.log("Matic", res.data.ETH.balance);
          //       this.balancedata = res.data.ETH.balance.toFixed(5);
          //     });
          // } else {
          //      axios
          //    .get(
          //        "https://api.polygonscan.com/api?module=account&action=tokenbalance&contractaddress=" +
          //         this.token.conAddress +
          //         "&address=" +
          //         this.token.ethAddress +
          //         "&tag=latest&apikey=37P5JKA8MP6PFCJM79NZFRHN37MIQACJNM"
          //     )
          //     .then((res) => {
          //       console.log("this.res", res);
          //       this.balancedata = res.data.result / 1e18;
          //     });

          // }
        });
    },

    // getCountry() {
    //   // console.log("data");
    //   APIService.getAllCountry().then((res) => {
    //     if (res.status == 200) {
    //       // console.log("res.data", res.data);
    //       this.countryInfo = res.data;
    //       for (let i in this.countryInfo) {
    //         this.country.push(res.data[i].name);
    //       }
    //     } else {
    //       // console.log("else", res);
    //     }
    //   });
    // },
  },
  created: function () {
    this.id = this.$route.params.id;
    console.log("id received", this.id);
    this.gettokens();
    // this.getCountry();
  },
};
</script>
<style >
.inputlength {
  background: darkgrey;
  font-size: large;
  width: 33px;
  text-align: center;
  font-weight: 500;
}
.nftbtnupdate {
  width: fit-content;
  /* margin-left: 20px; */
}
</style>

